interface FileSizeDisplayProps {
  bytes: number;
  className?: string;
}

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, i);
  return `${value.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

/**
 * Format a byte count that arrives as a DECIMAL STRING.
 *
 * Aggregate byte totals cross the wire as strings because the underlying column
 * is a BigInt: `JSON.stringify` throws on a BigInt, and a platform-wide total
 * can exceed `Number.MAX_SAFE_INTEGER`. Parsing through `BigInt` first keeps the
 * value exact until the final, deliberately lossy division for display.
 */
export function formatByteString(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  let n: number;
  try {
    n = Number(BigInt(value));
  } catch {
    return '—';
  }
  return Number.isFinite(n) ? formatBytes(n) : '—';
}

export function FileSizeDisplay({ bytes, className }: FileSizeDisplayProps) {
  return <span className={className}>{formatBytes(bytes)}</span>;
}
